import checkout from "./form2";

const {
  formField2: {
    countryName,
    airlinesName,
    startDate,
    endDate,
    supplementaryForThe,
    firstTime,
    vehicleName,
    taxAgencyId,
    taxAgencyName,
    agencyName,
    agencyId,
  },
} = checkout;

const initialValues2 = {
  [countryName.name]: "",
  [airlinesName.name]: "",
  [startDate.name]: "",
  [endDate.name]: "",
  [supplementaryForThe.name]: "",
  [firstTime.name]: false,
  [vehicleName.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [agencyName.name]: "",
  [agencyId.name]: "",
};

export default initialValues2;
